import {
  ClickAwayListener,
  Grow,
  Hidden,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import classNames from 'classnames';
import { logout } from 'lib';
import * as React from 'react';

interface Props extends Omit<ButtonProps, 'onClick'> {
  /** Logged-in account, shown so staff can see which login a screen is on. */
  email?: string;
}

const useStyles = makeStyles((theme) => ({
  btnText: {
    marginLeft: theme.spacing(1),
    display: 'inline-block',
    maxWidth: 260,
    ...theme.mixins.ellipsis,
    textTransform: 'none',
    verticalAlign: 'middle',
  },
  signedInAs: {
    // Disabled items fade to 50%; this line is information, keep it readable.
    '&.Mui-disabled': {
      opacity: 1,
    },
  },
  popperClose: {
    pointerEvents: 'none',
  },
  popperResponsive: {
    [theme.breakpoints.down('md')]: {
      ...theme.mixins.popperResponsive,
    },
  },
  dropdown: {
    ...theme.mixins.dropdown,
  },
  dropdownItem: {
    ...theme.mixins.dropdownItem,
  },
}));

interface State {
  anchorEl?: HTMLElement;
}

export const AccountButton: React.FC<Props> = ({ email, ...rest }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>();

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <Button onClick={handleClick} title={email} {...rest}>
        <Hidden xsDown>
          <span className={classes.btnText}>{email || 'Account'}</span>
        </Hidden>
      </Button>

      <Popper
        placement="bottom-start"
        open={open}
        className={classNames(classes.popperResponsive, {
          [classes.popperClose]: !open,
        })}
        anchorEl={anchorEl}
        transition
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClick}>
            <Grow {...TransitionProps}>
              <Paper className={classes.dropdown}>
                <MenuList role="menu">
                  {email && (
                    <MenuItem
                      disabled
                      className={classNames(
                        classes.dropdownItem,
                        classes.signedInAs,
                      )}
                    >
                      Signed in as {email}
                    </MenuItem>
                  )}
                  <MenuItem onClick={logout} className={classes.dropdownItem}>
                    Log out
                  </MenuItem>
                </MenuList>
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </Popper>
    </React.Fragment>
  );

  function handleClick({
    currentTarget,
  }: React.SyntheticEvent<HTMLElement | {}>) {
    setAnchorEl(
      anchorEl || !(currentTarget instanceof Element)
        ? undefined
        : currentTarget,
    );
  }
};
